const validateMobile = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('Mobile cannot be empty'))
  }
  if (!Number.isInteger(value)) {
    callback(new Error('Please enter a numeric value'))
  } else {
    if (value.toString().length !== 10) {
      callback(new Error('Length Must be equal to 10 digit'))
    } else {
      callback()
    }
  }
}
const validateMobileNumber = (rule, value, callback) => {
    if(!value){
        callback(new Error('Please enter Mobile'))
    }else if(value && value.toString().length !== 10) {
        callback(new Error('Length Must be equal to 10 digit'))
    } else {
        callback()
    }
}
const validateGSTIN = (rule, value, callback) => {
  if (!value) {
    callback()
  }
  if (value && value.toString().length !== 15) {
    callback(new Error('Length Must be equal to 15 digit'))
  } else {
    callback()
  }
}
const validateOTP = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('OTP cannot be empty'))
  }
  if (!Number.isInteger(value)) {
    callback(new Error('Please enter a numeric value'))
  } else {
    if (value.toString().length !== 4) {
      callback(new Error('Length Must be equal to 4 digit'))
    } else {
      callback()
    }
  }
}
const validatePIN = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('PIN cannot be empty'))
  }
  if (!Number.isInteger(value)) {
    callback(new Error('Please enter a numeric value'))
  } else {
    if (value.toString().length !== 6) {
      callback(new Error('Length Must be equal to 6 digit'))
    } else {
      callback()
    }
  }
}
const validateCityCode = (rule, value, callback) => {
    if(!value){
        callback(new Error('Please enter City Code'))
    }else if(value && value.toString().length !== 3) {
        callback(new Error('City Code must be of 3 characters'))
    } else {
        callback()
    }
}
const validateTextField = (rule, value, callback) => {
    if(!value || value.replace(/\s+/g, '').length === 0) {
        callback(new Error('Please enter ' + rule.label))
    } else {
        callback()
    }
}
const validateNumberField = (rule, value, callback) => {
    if(!value) {
        callback(new Error('Please enter ' + rule.field))
    }else if(value && value == 0) {
        callback(new Error(rule.field + ' must be greater than zero'))
    } else {
        callback()
    }
}
const validateSelectField = (rule, value, callback) => {
    if(!value) {
        callback(new Error('Please select ' + rule.field))
    } else {
        callback()
    }
}
const ValidationRules = {
  textField: function(label){
    return [{required: true, label:label, validator: validateTextField, trigger: 'change'}]
  },
  numberField: [
      {required: true, validator: validateNumberField, trigger: 'change'}
  ],
  selectField: [
      {required: true, validator: validateSelectField, trigger: 'change'}
  ],
  userType: [
    { required: true, message: 'Select User Type', trigger: 'blur' }
  ],
  name: [
    { required: true, message: 'The name cannot be empty', trigger: 'blur' }
  ],
  email: [
    { required: true, message: 'Email Required', trigger: 'blur' },
    { type: 'email', message: 'Incorrect email format', trigger: 'change' }
  ],
  mobile: [
    { required: true, validator: validateMobile, trigger: 'change' }
  ],
  mobileNumber: [
      { required: true, validator: validateMobileNumber, trigger: 'change' }
  ],
  cityCode: [
      { required: true, validator: validateCityCode, trigger: 'change' }
  ],
  otp: [
    { required: true, validator: validateOTP, trigger: 'change' }
  ],
  companyName: [
    { required: true, message: 'Enter Company Name', trigger: 'blur' }
  ],
  address1: [
    { required: true, message: 'Address Required', trigger: 'blur' }
  ],
  area: [
    { required: true, message: 'Area Required', trigger: 'blur' }
  ],
  pincode: [
    { required: true, validator: validatePIN, trigger: 'blur' }
  ],
  city: [
    { required: true, message: 'Please select the city', trigger: 'blur' }
  ],
  state: [
    { required: true, message: 'Please select the state', trigger: 'blur' }
  ],
  gstin: [
    { validator: validateGSTIN, trigger: 'change' }
  ]
}

export default ValidationRules
